import styled from "styled-components";
import { device } from "../App/StyleVariables";

const FooterWrap = styled.footer`
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  margin: 24rem auto 0;
  max-width: 58rem;

  @media ${device.sm} {
    flex-direction: row;
    margin-top: 32.2265625%;
  }

  @media ${device.md} {
    margin-top: 35.5%;
  }
`;

export default FooterWrap;
